import { contractMissionStatusConstante } from "@/constantes/mission";
import { formValidator } from "@/services/form/form-validator";

export const missionStatusFilterConstante = Object.freeze({
  ALL: "all",
  IN_PROGRESS: "in_progress",
  COMPLETED: "completed",
  ARCHIVED: "archived",
});

class MissionViewModelManager {
  toMissionViewModel(evolution) {
    return {
      id: evolution.contractMission?.id,
      evolutionId: evolution.id,
      name: evolution.contractMission?.name,
      startDate: evolution.contractMission?.startDate,
      endDate: evolution.contractMission?.endDate,
      status: evolution.contractMission?.status,
      levelOfAchievement: evolution.levelOfAchievement ?? 0,
      objectif: evolution.objectif,
      commentaire: evolution.commentaire,
      hasHistory: !!evolution.hasHistory,
    };
  }

  classifyMission(mission) {
    if (mission.status === contractMissionStatusConstante.ARCHIVED) {
      return missionStatusFilterConstante.ARCHIVED;
    }
    return mission.levelOfAchievement >= 100
      ? missionStatusFilterConstante.COMPLETED
      : missionStatusFilterConstante.IN_PROGRESS;
  }

  matchesStatusFilter(mission, statusFilter) {
    if (statusFilter === missionStatusFilterConstante.ALL) {
      return true;
    }
    return this.classifyMission(mission) === statusFilter;
  }

  // Point unique de filtre + tri partagé par QuestionnaireMissionComponent et
  // TriadDashboardMissionTabComponent (tous deux pilotés par QuestionnaireFilterBlockComponent) :
  // filtre les missions par statut (ALL les conserve toutes) puis les trie par la date choisie.
  filterAndSortMissions(missions, statusFilter, sort) {
    return missions
      .filter((mission) => this.matchesStatusFilter(mission, statusFilter))
      .sort((a, b) => new Date(a[sort]) - new Date(b[sort]));
  }

  getMissionObjectifFieldId(mission, editedMission) {
    const levelOfAchievement = editedMission?.levelOfAchievement ?? mission.levelOfAchievement;
    if (levelOfAchievement >= 100) {
      // Le champ objectif n'est pas affiché (remplacé par le commentaire facultatif).
      return false;
    }
    const objectif = editedMission ? editedMission.objectif : mission.objectif;
    const fieldId = "mission-preview-objectives-" + mission.id;
    return formValidator.isEmpty(objectif) ? fieldId : false;
  }

  isMissionObjectifMissing(mission, editedMission) {
    return !!this.getMissionObjectifFieldId(mission, editedMission);
  }
}

export const missionViewModelManager = new MissionViewModelManager();
